import { defineNuxtPlugin } from 'nuxt/app'
import { createGtm } from '@gtm-support/vue-gtm'
import { useRuntimeConfig } from '#app'

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(
    createGtm({
      id: useRuntimeConfig().public.gtmId
    })
  )
})
